import { FEATURES, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export default [
  {
    path: '/financeiro',
    name: 'finance',
    redirect: '/financeiro/geral',
    meta: {
      can_show: FEATURES.BPO_FINANCE,
      search: {
        title: 'Financeiro',
        description: 'DRE, DFC e resultado financeiro do escritório',
        keywords: ['financeiro', 'dre', 'dfc', 'resultado', 'contábil'],
        icon: 'usd-circle',
        group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
      },
    },
    component: () =>
      lazyLoadView(import('@src/modules/finance/views/finance-nav-bar')),
    children: [
      {
        path: 'geral',
        name: 'finance.overview',
        meta: {
          can_show: FEATURES.BPO_FINANCE,
          permission: ['all'],
          search: {
            title: 'Financeiro — Visão Geral',
            description: 'Visão geral do resultado financeiro',
            keywords: ['financeiro', 'visão geral', 'resumo', 'resultado'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(import('@modules/finance/views/view-finance-overview')),
      },
      {
        path: 'demonstrativo',
        name: 'finance.dre',
        meta: {
          can_show: [FEATURES.BPO_FINANCE, FEATURES.P_L_PJ],
          permission: ['gestor'],
          search: {
            title: 'Financeiro — Demonstrativos (DRE e DFC)',
            description: 'Demonstrativo de resultado e fluxo de caixa',
            keywords: [
              'dre',
              'dfc',
              'demonstrativo',
              'fluxo de caixa',
              'resultado',
            ],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(import('@modules/finance/views/view-finance-dre')),
      },
      {
        path: 'profissional',
        name: 'finance.professional',
        meta: {
          can_show: [FEATURES.BPO_FINANCE, FEATURES.P_L_PROFISSIONAL],
          permission: ['all'],
          search: {
            title: 'Financeiro — Profissional',
            description: 'Resultado financeiro por profissional',
            keywords: ['profissional', 'assessor', 'resultado', 'financeiro'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@modules/finance/views/view-finance-professional')
          ),
        children: [
          {
            path: ':id_profissional',
            name: 'finance.professional.result',
            meta: {
              can_show: [FEATURES.BPO_FINANCE, FEATURES.P_L_PROFISSIONAL],
            },
            component: () =>
              lazyLoadView(
                import('@modules/finance/views/view-finance-professional')
              ),
          },
        ],
      },
      {
        path: 'produto',
        name: 'finance.product',
        meta: {
          can_show: [FEATURES.BPO_FINANCE, FEATURES.P_L_AREA_DE_RECEITA],
          permission: ['all'],
          search: {
            title: 'Financeiro — Produto',
            description: 'Resultado financeiro por área de receita',
            keywords: ['produto', 'área de receita', 'receita', 'financeiro'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(import('@modules/finance/views/view-finance-product')),
      },
      {
        path: 'filial',
        name: 'finance.filial',
        meta: {
          can_show: [FEATURES.BPO_FINANCE, FEATURES.P_L_FILIAL],
          permission: ['all'],
          search: {
            title: 'Financeiro — Filial',
            description: 'Resultado financeiro por filial',
            keywords: ['filial', 'unidade', 'resultado', 'financeiro'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(import('@modules/finance/views/view-finance-filial')),
      },
      {
        path: 'equipe',
        name: 'finance.team',
        meta: {
          can_show: [FEATURES.BPO_FINANCE, FEATURES.P_L_EQUIPE],
          search: {
            title: 'Financeiro — Equipe',
            description: 'Resultado financeiro por equipe',
            keywords: ['equipe', 'time', 'resultado', 'financeiro'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(import('@modules/finance/views/view-finance-team')),
      },
      {
        path: 'comparativo',
        name: 'finance.comparative',
        meta: {
          can_show: FEATURES.BPO_FINANCE,
          search: {
            title: 'Financeiro — Comparativo',
            description: 'Comparativo de resultados financeiros',
            keywords: ['comparativo', 'comparação', 'período', 'financeiro'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@modules/finance/views/comparative/view-comparative')
          ),
      },
      {
        path: 'orcado_realizado',
        name: 'finance.orcado_realizado',
        meta: {
          can_show: FEATURES.ORCADO_REALIZADO,
          search: {
            title: 'Financeiro — Orçado vs Realizado',
            description: 'Comparação entre orçamento e realizado',
            keywords: [
              'orçado',
              'realizado',
              'orçamento',
              'budget',
              'planejamento',
            ],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/partnership/views/view-orcado-realizado/orcado-realizado.vue'
            )
          ),
      },
    ],
  },
]
